export enum TranslationKeySubPathEnum {
  BIRTHDAY = 'birthday.',
  PRODUCT_TEST = 'product_test.',
}
